import { ActionTypes } from "../actions"
import combineReducers, {
  StateFromReducersMapObject,
} from "../../utils/combine-reducer"
import { DropitState } from "."
import { Roles } from "../../utils"
import { ISupplierInfo } from "../../models"

const role = (state: Roles = Roles.SUPPLIER, action: any): Roles => {
  switch (action.type) {
    case ActionTypes.SET_ROLE:
      return action.role
    default:
      return state
  }
}

const managedSupplierList = (
  state: ISupplierInfo[] = [],
  action: any
): ISupplierInfo[] => {
  switch (action.type) {
    case ActionTypes.SET_MANAGED_SUPPLIER_LIST:
      return action.managedSupplierList
    default:
      return state
  }
}

const selectedSupplier = (
  state: ISupplierInfo = { supplierName: "", eanMandatory: true },
  action: any
): ISupplierInfo => {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_SUPPLIER:
      return action.supplier
    default:
      return state
  }
}

const supplierBusinessUnit = (state = "", action: any): string => {
  switch (action.type) {
    case ActionTypes.SET_BUSINESS_UNIT:
      return action.businessUnits.supplierBusinessUnit
    default:
      return state
  }
}

const currentUserBusinessUnit = (state = "", action: any): string => {
  switch (action.type) {
    case ActionTypes.SET_BUSINESS_UNIT:
      return action.businessUnits.marketLeaderBusinessUnit
    default:
      return state
  }
}

const reducers = {
  role,
  managedSupplierList,
  selectedSupplier,
  supplierBusinessUnit,
  currentUserBusinessUnit,
}

type UserState = StateFromReducersMapObject<typeof reducers>

export default combineReducers<UserState>({ ...reducers })

export const getRole = (state: DropitState["user"]) => state.role
export const getSelectedSupplier = (state: DropitState["user"]) =>
  state.selectedSupplier
export const getManagedSupplierList = (state: DropitState["user"]) =>
  state.managedSupplierList
export const getSupplierBusinessUnit = (state: DropitState["user"]) =>
  state.supplierBusinessUnit
export const getCurrentUserBusinessUnit = (state: DropitState["user"]) =>
  state.currentUserBusinessUnit
